/**
 * Show/hide the place holders depending when new components tab is open or when sorting
 * and a component column container is empty
 *
 */

import UpdateMasonryEvents from "./updateMasonryEvents";
import { isOpen as isNewComponentTabsOpen } from "./newComponents/newComponentsTabs";

const COMPONENT_CONTAINERS_SELECTOR = "[data-components-container]"; //the top/left/right parent containers

let __placeHolderComponentsList = []; //to contain the place holder instances

/**
 * Fire everything up
 */
export function initUpdatePlaceHolders() {
    initPlaceHolderComponents();
    if (isNewComponentTabsOpen()) addPlaceHolderComponents();
    document.addEventListener(UpdateMasonryEvents.COMPONENT_ADDED, onComponentUpdate);
    document.addEventListener(UpdateMasonryEvents.COMPONENT_REMOVED, onComponentUpdate);
    document.addEventListener(UpdateMasonryEvents.EXISTING_COMPONENT_SORT_START, addPlaceHolderComponents);
    document.addEventListener(UpdateMasonryEvents.NEW_COMPONENTS_TABS_OPENED, addPlaceHolderComponents);
    document.addEventListener(UpdateMasonryEvents.EXISTING_COMPONENT_SORT_UPDATE, updatePlaceHolderComponents);
    document.addEventListener(UpdateMasonryEvents.NEW_COMPONENT_SORT_UPDATE, updatePlaceHolderComponents);
    document.addEventListener(UpdateMasonryEvents.EXISTING_COMPONENT_SORT_END, onExistingComponentSortEnd);
    document.addEventListener(UpdateMasonryEvents.NEW_COMPONENTS_TABS_CLOSED, removePlaceHolderComponents);
}

/**
 * Need to run through and check each parent container for children
 * if there's no children need to show that items can be dragged into this container
 */
function initPlaceHolderComponents() {
    document.querySelectorAll(COMPONENT_CONTAINERS_SELECTOR).forEach((container, index) => {
        const placeHolderComponent = document.createElement("div");
        placeHolderComponent.id = `placeHolderComponent-${index}`;
        placeHolderComponent.classList.add("masonry-placeholder");
        placeHolderComponent.style.display = "block";
        placeHolderComponent.style.height = "51px";
        placeHolderComponent.dataset.component = "true";
        placeHolderComponent.dataset.placeHolderComponent = "true"; //to distinguish it from the components, used in removePlaceHolderComponents()
        placeHolderComponent.innerText = "You can drag components into this space";
        __placeHolderComponentsList = [...__placeHolderComponentsList, placeHolderComponent];
    });
}

/**
 * Remove and re-add as a component has been added / removed
 */
function onComponentUpdate() {
    removePlaceHolderComponents();
    if (isNewComponentTabsOpen()) {
        //only show them again when the tabs are open
        addPlaceHolderComponents();
    }
}

/**
 * Need to run through and check each parent container for children
 * if there's no children except the .masonry-placeholder need to show that items can be dragged into this container
 */
function addPlaceHolderComponents() {
    document.querySelectorAll(COMPONENT_CONTAINERS_SELECTOR).forEach((parentContainer, index) => {
        if (canAddPlaceHolderComponent(parentContainer)) {
            const placeHolderComponent = __placeHolderComponentsList[index];

            if (parentContainer.firstChild !== null) {
                // if we already have components, insert the placeholder before the first component
                parentContainer.insertBefore(placeHolderComponent, parentContainer.firstChild);
            } else {
                parentContainer.append(placeHolderComponent);
            }
        }
    });
}

/**
 * Is the parent container empty? If so a place holder can be added
 *
 * @param { Element }
 *
 * @returns { Boolean }
 */
function canAddPlaceHolderComponent(parentContainer) {
    return parentContainer.children.length === 0;
}

/**
 * Remove and re-add as parent containers have changed
 */
function updatePlaceHolderComponents() {
    removePlaceHolderComponents();
    addPlaceHolderComponents();
}

/**
 * Remove all the placeholders only if the new component tabs aren't open
 */
function onExistingComponentSortEnd() {
    if (!isNewComponentTabsOpen()) {
        //don't hide them when the new component tabs is open
        removePlaceHolderComponents();
    }
}

/**
 * Remove all the placeholders
 */
function removePlaceHolderComponents() {
    document.querySelectorAll("[data-place-holder-component]").forEach((placeHolderComponent) => {
        placeHolderComponent.remove(); //will just fail silently if isn't in the DOM
    });
}
